import { Select, Tooltip } from 'antd';
import { jsx as _jsx } from "react/jsx-runtime";
var textStyles = {
  type: 'select',
  options: [{
    value: 'paragraph',
    label: 'Paragraph'
  }, {
    value: '2',
    label: 'Heading 1'
  }, {
    value: '3',
    label: 'Heading 2'
  }, {
    value: '4',
    label: 'Heading 3'
  }, {
    value: '5',
    label: 'Heading 4'
  }],
  onChange: function onChange(editor, value) {
    if (value === 'paragraph') {
      editor.chain().focus().setParagraph().run();
    } else {
      editor.chain().focus().toggleHeading({
        level: parseInt(value)
      }).run();
    }
  },
  getValue: function getValue(editor) {
    var state = editor.state;
    var _state$selection = state.selection,
        from = _state$selection.from,
        to = _state$selection.to;
    var level = 'paragraph';
    state.doc.nodesBetween(from, to, function (node) {
      if (node.type.name === 'heading') {
        level = node.attrs.level.toString();
      }
    });
    return level;
  }
};
export var TextStylesMenu = function TextStylesMenu(_ref) {
  var editor = _ref.editor,
      labels = _ref.labels;
  return /*#__PURE__*/_jsx(Tooltip, {
    title: labels === null || labels === void 0 ? void 0 : labels.textStyles,
    children: /*#__PURE__*/_jsx(Select, {
      bordered: false,
      value: textStyles.getValue(editor),
      style: {
        width: 120
      },
      onChange: function onChange(value) {
        return textStyles.onChange(editor, value);
      },
      options: textStyles.options
    })
  });
};